export default __webpack_public_path__ + "static/logo-fafe8163a929d59754b95fffd2a59763.svg";